let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dl3k2")).then(() => parcelRequire('cIqRB'));